import LocationPinIcon from "atoms/icon/icons/location-pin.svg";

export interface LocationDetailsCardProps {
  onLocationChangeRequest: () => void;
  displayedLocationName: string;
  cartHasRetailProducts: boolean;
}

export const LocationDetailsCard = ({
  onLocationChangeRequest,
  displayedLocationName,
  cartHasRetailProducts,
}: LocationDetailsCardProps) => {
  return (
    <div className="flex flex-col">
      <div className="bg-two pt-2" />
      <button
        type="button"
        className="w-full text-left"
        onClick={() => {
          onLocationChangeRequest();
        }}
      >
        <div className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-start gap-1">
              <LocationPinIcon
                className="mt-1 fill-brand-color"
                width="30"
                height="30"
              />
              <div className="flex flex-col">
                <div className="text-sm">
                  {cartHasRetailProducts
                    ? "These items must be redeemed at our"
                    : "These services must be booked at our"}
                </div>
                <div className="flex items-baseline gap-1">
                  <span className="font-medium">{displayedLocationName}</span>
                  <span className="text-sm">location</span>
                </div>
              </div>
            </div>
            <span className="text-sm font-medium text-primary">EDIT</span>
          </div>
        </div>
      </button>
    </div>
  );
};
